import {create} from 'zustand'
import {devtools} from 'zustand/middleware'

import {ILoginState, ILoginActions} from './login.type'
import { auth, getApplicationNumber, getCourseName, getProgramInfo } from './login.actions'


export const initialStateLogin: ILoginState = {
    error: null,
    isLoading: false,
}

/** Хранилище страницы - Авторизация */
export const useLogin = create<ILoginState & ILoginActions>()(devtools((set) => ({
    ...initialStateLogin,

    /** Авторизация в системе */
    actionLogin: async (verifCode: number, typeForm: string, name: string, phone: string, courseID: string, courseProgramID: string, files: File[]) => {
        let returnResult: boolean = false
        set({isLoading: true})

        const res = await auth(verifCode, typeForm, name, phone, courseID, courseProgramID, files)
        if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        if (res.message === 'OK') {
            set({error: null})
            returnResult = true
        }

        set({isLoading: false})
        return returnResult
    },

    /**  */
    actionCourseName: async (courseID: string) => {
        const res = await getCourseName(courseID)
        if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        if (res.message === 'OK') {
            set({error: null})
            return {courseName: res.data?.courseName}
        }

        return undefined
    },

    /**  */
    actionProgramInfo: async (courseProgramID: string) => {
        const res = await getProgramInfo(courseProgramID)
        if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        if (res.message === 'OK') {
            set({error: null})
            return {
                volumeHours: res.data?.volumeHours,
                durationEducation: res.data?.durationEducation,
                programName: res.data?.programName,
            }
        }

        return undefined
    },

    /**  */
    actionApplicationNumber: async (phoneNumber: string) => {
        const res = await getApplicationNumber(phoneNumber)
        if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        if (res.message === 'OK') {
            set({error: null})
            return {
                applicationNumber: res.data?.applicationNumber
            }
        }

        return undefined
    }

}), {name: 'loginState'}))